<template>
  <router-view/>
</template>

<script>
export default {
  name: "Operation"
};
</script>
